import React from 'react';

const Subscription = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Subscription</h1>
      <p>Manage your subscription plan and payment details here.</p>
      {/* Add your subscription management UI here */}
    </div>
  );
};

export default Subscription; 